import { createApp } from 'vue'
import App from './App.vue'
// import {changeBig } from '@/utils/appUI.js'
import router from './router'
import store from './store'
import 'normalize.css'
import '@/style/index.scss'

import "@babel/polyfill";
// import VueQrcodeReader from 'vue-qrcode-reader';
import VueGoogleMaps from '@fawmi/vue-google-maps';
// vant
import { Button, Field, Picker, RadioGroup, Radio, Popup, Cell, Form, CellGroup, Cascader, NavBar, Icon, DatePicker, Checkbox, CheckboxGroup, Uploader, Image as VanImage, Tab, Tabs, Search, List, Switch, Dialog, Stepper, Loading, PullRefresh, Tag, Popover, ConfigProvider, DropdownMenu, DropdownItem, Calendar, Swipe, SwipeItem, Step, Steps, IndexBar, IndexAnchor, } from 'vant';
import 'vant/lib/index.css'; // 引入样式

import { createI18n } from 'vue-i18n';
import { Locale } from 'vant'; // 国际化
import messages from './locales/i18n-messages';
import { Toast } from 'vant';
import { getCurrentLanguage } from '@/effects/switchLanguageEffect'

// vant
import { GOOGLE_MAP_KEY } from '@/utils/config'

import { googleMapParam } from '@/utils/mapConfig'

// import { } from '@/utils/map'



// 报表
// import { Chart, registerables } from 'chart.js'
// Chart.register(...registerables)

// import { getGeoByMapTiler } from "@/utils/map.js";
// const geo = await getGeoByMapTiler("上海市长宁区延安西路1448弄3号");
// console.log(geo.longitude, geo.latitude); // WGS84

import VueECharts from 'vue-echarts'
import * as ECharts from 'echarts'


//动态计算视口高度 为了适配底部有导航栏的手机端
function updateVh() {
    const vh = window.innerHeight * 0.01;
    console.log('updateVh', vh)
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', updateVh);
updateVh();
//动态计算视口高度 为了适配底部有导航栏的手机端





const i18n = createI18n({
    locale: getCurrentLanguage(), // 默认语言
    messages,
});

// Locale.use('en-US', enUS);
// Locale.use('zh-CN', zhCN);
// Locale.use('ms-MY', Malay); // 将马来语设置为当前语言
Locale.use(i18n.global.locale, i18n.global.getLocaleMessage(i18n.global.locale).van);



var width = document.documentElement.clientWidth || document.body.clientWidth
console.log('width width width', width)
const isMobile = width <= 768;
if (!isMobile) {
    import('@/style/browser.scss').then(() => {
        console.log('browser.scss 加载成功');
    });
}


// .use(NumberKeyboard)
// .use(TimePicker)
// .use(VueQrcodeReader)

// JavaScript 动态处理（针对 iOS 设备） 缩放处理
document.addEventListener('focusin', () => {
    document.body.style.transform = 'scale(1)';
});
document.addEventListener('focusout', () => {
    document.body.style.transform = '';
});
// JavaScript 动态处理（针对 iOS 设备）






createApp(App)
    .component('v-chart', VueECharts)
    .use(store)
    .use(router)
    .use(Button)
    .use(Field)
    .use(Picker)
    .use(RadioGroup)
    .use(Radio)
    .use(Cascader)
    .use(i18n)
    .use(Toast)
    .use(Popup)
    .use(Cell)
    .use(CellGroup)
    .use(NavBar)
    .use(Icon)
    .use(DatePicker)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Uploader)
    .use(VanImage)
    .use(Tab)
    .use(Tabs)
    .use(Search)
    .use(List)
    .use(Switch)
    .use(Dialog)
    .use(Stepper)
    .use(Loading)
    .use(PullRefresh)
    .use(Tag)
    .use(Popover)
    .use(ConfigProvider)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(Calendar)
    .use(Swipe)
    .use(SwipeItem)
    .use(Form)
    .use(Step)
    .use(Steps)
    .use(IndexBar)
    .use(IndexAnchor)
    // .use(FloatingBubble)
    .use(VueGoogleMaps, googleMapParam
    )

    .mount('#app')

//  {
//     load: {
//         key: GOOGLE_MAP_KEY,
//         language: 'zh-CN',
//         region: 'CN',
//         v: 'weekly', // 指定使用最新的稳定版本
//         // version: "3.49", // 指定稳定版本
//     },
// }